//camera.js
import { clamp } from './utils';
import { CAMERA } from './constants';

export function createCamera() {
  return {
    ...CAMERA.DEFAULT,
    tx: CAMERA.DEFAULT.x,
    ty: CAMERA.DEFAULT.y,
    moveSpeed: CAMERA.MOVE_SPEED,

    ts: CAMERA.DEFAULT.scale,
    zoomSpeed: CAMERA.ZOOM_SPEED,
  };
}

export function clampCameraToWorld(
  camera,
  viewport,
  world,
  allowFactor = CAMERA.ALLOW_FACTOR,
) {
  // 화면 반 (월드 단위)
  const halfW = viewport.width / 2 / camera.scale;
  const halfH = viewport.height / 2 / camera.scale;

  // 월드 사각형
  const left = world.originX;
  const right = world.originX + world.w;
  const top = world.originY;
  const bottom = world.originY + world.h;

  // 허용 확장
  const padX = (world.w * (allowFactor - 1)) / 2;
  const padY = (world.h * (allowFactor - 1)) / 2;

  const extLeft = left - padX;
  const extRight = right + padX;
  const extTop = top - padY;
  const extBottom = bottom + padY;

  // 카메라 중심이 갈 수 있는 범위
  let minX = extLeft + halfW;
  let maxX = extRight - halfW;
  let minY = extTop + halfH;
  let maxY = extBottom - halfH;

  // 줌 아웃으로 화면이 허용영역보다 커질 때: 중앙 고정
  if (minX > maxX) {
    const midX = (extLeft + extRight) / 2;
    minX = maxX = midX;
  }
  if (minY > maxY) {
    const midY = (extTop + extBottom) / 2;
    minY = maxY = midY;
  }

  camera.x = clamp(camera.x, minX, maxX);
  camera.y = clamp(camera.y, minY, maxY);
}

export function beginCamera(ctx, camera, viewport) {
  ctx.save();
  ctx.translate(viewport.width / 2, viewport.height / 2);
  ctx.scale(camera.scale, camera.scale);
  ctx.translate(-camera.x, -camera.y);
}

export function endCamera(ctx) {
  ctx.restore();
}
